import { StoryNodeDisplayType } from "../storyV2/domain/StoryNodeDisplayType";
export class StoryNodeValidator {
    static isValidStoryNodeDisplayType(input) {
        return Object.values(StoryNodeDisplayType).includes(input);
    }
}
